import React from "react";
import { approachSteps } from "../mock";
import { CheckCircle2 } from "lucide-react";
import useSeo from "../hooks/useSeo";

const Approach = () => {
  useSeo({
    title: "Our Approach",
    description:
      "A structured, transparent path from idea to impact: Discovery, Strategy, Execution and Growth. See how Astoria Solutions delivers reliably.",
    path: "/approach",
  });
  return (
    <>
      <section className="bg-black text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-extrabold">Our Approach</h1>
          <p className="mt-4 text-teal-400">A structured, transparent path from idea to impact.</p>
        </div>
      </section>

      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {approachSteps.map((s) => (
              <div
                key={s.step}
                className="relative bg-neutral-50 rounded-2xl p-8 border border-neutral-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="absolute -top-6 left-8 w-14 h-14 rounded-full bg-teal-500 text-white text-xl font-bold flex items-center justify-center shadow-md">
                  {s.step}
                </div>
                <h3 className="mt-8 text-2xl font-bold text-neutral-900">{s.title}</h3>
                <p className="mt-3 text-neutral-600 leading-relaxed">{s.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 bg-neutral-900 text-white rounded-2xl p-10 md:p-14 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-extrabold">Why our clients stay</h3>
              <p className="mt-3 text-neutral-300">
                A blend of research rigor, financial acumen and delivery discipline that scales with you.
              </p>
            </div>
            <ul className="space-y-3">
              {[
                "Transparent, weekly progress reporting",
                "Dedicated senior specialists on every project",
                "Outcome-first pricing and clear KPIs",
                "Ongoing post-launch optimization"
              ].map((t) => (
                <li key={t} className="flex items-start gap-3 text-neutral-100">
                  <CheckCircle2 className="w-5 h-5 text-teal-400 mt-0.5 shrink-0" />
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
};

export default Approach;
